import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/settings.svg'
import _imports_1 from '@/assets/icons/svg/logout.svg'


const _withScopeId = n => (_pushScopeId("data-v-653b3c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative w-screen h-screen overflow-hidden z-0" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row flex-wrap justify-end h-32",
  style: {"width":"500px"}
}
const _hoisted_3 = { class: "w-24 h-24 cursor-pointer pointer-events-auto rounded-full flex flex-col justify-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "bg-gray-100 w-64 overflow-hidden" }
const _hoisted_6 = {
  key: 0,
  class: "w-full flex flex-col cursor-pointer pointer-events-auto font-serious text-sm"
}
const _hoisted_7 = {
  key: 0,
  class: "py-24 font-playful font-bold text-lg ml-4"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-4 w-10" }, null, -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex flex-grow" }, "Monitor", -1 /* HOISTED */))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-4 w-10" }, null, -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex flex-grow" }, "Games", -1 /* HOISTED */))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-4 w-10" }, null, -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex flex-grow" }, "Players", -1 /* HOISTED */))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-blue-button rounded-full mx-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "settings",
    class: "w-10 h-10 p-2"
  })
], -1 /* HOISTED */))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex flex-grow" }, "Settings", -1 /* HOISTED */))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-4 font-bold" }, "→", -1 /* HOISTED */))
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-blue-button rounded-full mx-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "log out",
    class: "w-10 h-10 p-2.5"
  })
], -1 /* HOISTED */))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex flex-grow" }, "Log Out", -1 /* HOISTED */))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_30 = {
  key: 1,
  class: "w-full flex flex-col cursor-pointer pointer-events-auto"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-4" }, "←", -1 /* HOISTED */))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "w-full flex flex-row items-center pt-8" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Remember Me"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" (expires in 3 days) ")
], -1 /* HOISTED */))
const _hoisted_35 = {
  key: 0,
  class: "w-full flex flex-col items-center pt-8"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mx-4" }, "Set a password", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_AnswerInput = _resolveComponent("AnswerInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view, { class: "z-0" }),
    _createCommentVNode(" Right panel "),
    _createElementVNode("div", {
      class: _normalizeClass(["absolute top-0 right-0 z-10 h-full transition duration-500 ease-in-out flex flex-row pointer-events-none", _ctx.rightMenuActive ? '-translate-x-full ease-out transition-medium' : 'translate-x-0 ease-in transition-medium'])
    }, [
      _createCommentVNode("Avatar :layout=\"game.profile.avatar\" id=\"div-avatarmenu\" @click=\"toggleRightMenu\" class=\"w-32 h-32 p-2 cursor-pointer pointer-events-auto\" /"),
      (_ctx.game && _ctx.playerListForGame.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playerListForGame, (p) => {
              return (_openBlock(), _createBlock(_component_Avatar, {
                id: `game-player-${p._id}`,
                key: `game-player-${p._id}`,
                layout: p.profile.avatar,
                class: _normalizeClass(["cursor-pointer pointer-events-auto", _ctx.game && _ctx.game.activePlayers.length > 1 ? 'w-16 h-16' : 'w-32 h-32']),
                onClick: _ctx.toggleRightMenu
              }, null, 8 /* PROPS */, ["id", "layout", "class", "onClick"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "w-32 h-32 p-4",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleRightMenu && _ctx.toggleRightMenu(...args)))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                class: "w-96",
                src: _ctx.enigImage,
                alt: "main menu image"
              }, null, 8 /* PROPS */, _hoisted_4)
            ])
          ])),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_Transition, {
          mode: "out-in",
          name: _ctx.rightMenuTransitionName
        }, {
          default: _withCtx(() => [
            (_ctx.rightMenuLevel == 'main')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.game)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.game.name), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _hoisted_8,
                  (_ctx.hasMonitorRole)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        id: "div-menu-monitor",
                        class: "w-full flex flex-row items-center h-14",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.monitor()))
                      }, _hoisted_11))
                    : _createCommentVNode("v-if", true),
                  _hoisted_12,
                  _createElementVNode("div", {
                    id: "div-menu-participants",
                    class: "w-full flex flex-row items-center h-14",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToGames()))
                  }, _hoisted_15),
                  _hoisted_16,
                  _createElementVNode("div", {
                    id: "div-menu-avatarcreator",
                    class: "w-full flex flex-row items-center h-14",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.avatarCreator()))
                  }, _hoisted_19),
                  _hoisted_20,
                  _createElementVNode("div", {
                    id: "div-menu-settings-on",
                    class: "w-full flex flex-row items-center h-14",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSettings()))
                  }, _hoisted_24),
                  _hoisted_25,
                  _createElementVNode("div", {
                    id: "div-menu-logout",
                    class: "w-full flex flex-row items-center h-14",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.logout()))
                  }, _hoisted_28),
                  _hoisted_29
                ]))
              : (_ctx.rightMenuLevel == 'settings')
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", {
                      id: "div-menu-settings-off",
                      class: "w-full flex flex-row items-center pt-8 m-2",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSettings()))
                    }, _hoisted_32),
                    _createElementVNode("div", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        id: "input-settings-rememberme",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rememberMe) = $event)),
                        class: "w-8 mx-4",
                        type: "checkbox"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, _ctx.rememberMe]
                      ]),
                      _hoisted_34
                    ]),
                    (_ctx.rememberMe)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _hoisted_36,
                          (_ctx.localUser)
                            ? (_openBlock(), _createBlock(_component_AnswerInput, {
                                key: 0,
                                id: "input-pin",
                                modelValue: _ctx.localUser.pin,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localUser.pin) = $event)),
                                mode: "text",
                                border: false
                              }, null, 8 /* PROPS */, ["modelValue"]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["name"])
      ])
    ], 2 /* CLASS */)
  ]))
}